module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAnCAMAAADTjiM/AAAARVBMVEUAAADBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHG7iTXAAAAFnRSTlMA8veNe1A/ZN/DMSQZ6AnSs6ER63NeeKPGAAAAAJBJREFUKM+t01sOhSAMRVHB+sA33mvnP1Trt7shRvlkEUJPaSUxTRWsoNqPsF+r6jw4EFoAMYgNQGegHUATDQSgDQY1wDAb5OUOY2+wAUyrQdrvsCeDFTJZNnUyyQa/R5n8vUyO+Fkmx/Uq57wU7uce8fvL9Wb4M5An5A/9wv7yf3Cyelm7FGv356U8XxJwHk8xXA27AXVjJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/more-arrow.png
// module id = 44
// module chunks = 0